"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _storePoint = require("@/api/storePoint");
var _user = require("@/api/user");
var _public = require("@/libs/public");
var _validate = require("@/utils/validate");
var _UserSearchInput = _interopRequireDefault(require("@/components/base/UserSearchInput.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'addClerk',
  components: {
    UserSearchInput: _UserSearchInput.default
  },
  props: {
    storeSelectList: Array
  },
  data: function data() {
    return {
      loading: false,
      dialogFormVisible: false,
      id: 0,
      ruleForm: {
        phone: '',
        storeId: '',
        uid: '',
        avatar: '',
        staffName: '',
        verifyStatus: 1,
        type: 2 // 用户类型：1-管理后台用户，2-小程序用户（此处固定小程序用户）
      },
      name: '',
      selectedName: '',
      // 所选核销员（用户）名称，仅用于展示，不与"核销员名称"输入联动
      rules: {
        uid: [{
          required: true,
          message: '请选择核销员',
          trigger: 'change'
        }],
        storeId: [{
          required: true,
          message: '请选择提货点地址',
          trigger: 'change'
        }]
      },
      // 选择核销员（用户）弹窗
      clerkDialog: false,
      clerkList: [],
      clerkLoading: false,
      clerkTotal: 0,
      clerkRadio: null,
      clerkSelected: null,
      clerkFrom: {
        page: 1,
        limit: 10,
        searchType: 'all',
        content: ''
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    // 打开选择核销员弹窗
    openClerkDialog: function openClerkDialog() {
      this.clerkFrom.page = 1;
      this.clerkFrom.searchType = 'all';
      this.clerkFrom.content = '';
      this.clerkRadio = this.ruleForm.uid || null;
      this.clerkSelected = this.ruleForm.uid ? {
        uid: this.ruleForm.uid,
        nickname: this.selectedName,
        phone: this.ruleForm.phone,
        avatar: this.ruleForm.avatar
      } : null;
      this.clerkDialog = true;
      this.getClerkList();
    },
    // 用户列表
    getClerkList: function getClerkList() {
      var _this = this;
      this.clerkLoading = true;
      (0, _user.userListApi)(_objectSpread(_objectSpread({}, this.clerkFrom), {}, {
        userType: 'routine'
      })).then(function (res) {
        _this.clerkList = res.list || [];
        _this.clerkTotal = res.total || 0;
        _this.clerkLoading = false;
      }).catch(function () {
        _this.clerkLoading = false;
      });
    },
    clerkSearch: function clerkSearch() {
      this.clerkFrom.page = 1;
      this.getClerkList();
    },
    resetClerkSearch: function resetClerkSearch() {
      this.clerkFrom.searchType = 'all';
      this.clerkFrom.content = '';
      this.clerkFrom.page = 1;
      this.getClerkList();
    },
    selectClerkRow: function selectClerkRow(row) {
      this.clerkRadio = row.uid;
      this.clerkSelected = row;
    },
    // 确定：带入用户信息（名称、手机号）
    confirmClerk: function confirmClerk() {
      if (!this.clerkSelected) return this.$message.warning('请选择核销员');
      var row = this.clerkSelected;
      this.ruleForm.uid = row.uid;
      this.ruleForm.avatar = row.avatar;
      this.selectedName = row.nickname; // 仅用于展示所选用户名称，不联动"核销员名称"
      this.ruleForm.staffName = row.nickname; // 仅用于展示所选用户名称，不联动"核销员名称"
      // this.ruleForm.phone = row.phone || ''; // 手机号码带入所选用户手机号
      if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('uid');
      this.clerkDialog = false;
    },
    clerkPageChange: function clerkPageChange(page) {
      this.clerkFrom.page = page;
      this.getClerkList();
    },
    clerkSizeChange: function clerkSizeChange(val) {
      this.clerkFrom.limit = val;
      this.getClerkList();
    },
    //详情
    getInfo: function getInfo(id) {
      var _this2 = this;
      this.id = id;
      this.loading = true;
      (0, _storePoint.storeStaffInfoApi)({
        id: id
      }).then(function (res) {
        _this2.ruleForm = res;
        _this2.ruleForm.type = 2; // 固定小程序用户
        _this2.selectedName = res.nickname || res.staffName || ''; // 回显所选用户名称
        _this2.loading = false;
      }).catch(function (res) {
        _this2.loading = false;
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.resetForm('ruleForm');
      this.ruleForm.avatar = '';
      this.id = 0;
    },
    //数据归为初始状态
    clearFrom: function clearFrom() {
      this.ruleForm.phone = '';
      this.ruleForm.staffName = '';
      this.ruleForm.uid = '';
      this.ruleForm.avatar = '';
      this.ruleForm.type = 2;
      this.selectedName = '';
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 提交
    submitForm: (0, _validate.Debounce)(function (name) {
      var _this3 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          var phone = _this3.ruleForm.phone;
          if (phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
              return _this3.$message.error('手机号格式不正确');
            }
          }
          (0, _storePoint.storeStaffSaveApi)(_this3.ruleForm).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this3.$message.success('提交成功');
                  _this3.dialogFormVisible = false;
                  _this3.$emit('tableList');
                  _this3.clearFrom();
                  _this3.resetForm(name);
                  _this3.id = 0;
                  (0, _public.getStoreStaff)();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          })));
        } else {
          return false;
        }
      });
    }),
    //  编辑
    editForm: (0, _validate.Debounce)(function (name) {
      var _this4 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          var phone = _this4.ruleForm.phone;
          if (phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
              return _this4.$message.error('手机号格式不正确');
            }
          }
          (0, _storePoint.storeStaffUpdateApi)(_this4.ruleForm).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this4.$message.success('编辑成功');
                  _this4.dialogFormVisible = false;
                  _this4.$emit('tableList');
                  _this4.clearFrom();
                  _this4.resetForm(name);
                  _this4.id = 0;
                  (0, _public.getStoreStaff)();
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          })));
        } else {
          return false;
        }
      });
    })
  }
};